import { render, staticRenderFns } from "./GbsHelpViewBulkImport.vue?vue&type=template&id=09621651"
import script from "./GbsHelpViewBulkImport.vue?vue&type=script&lang=ts"
export * from "./GbsHelpViewBulkImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports